export const FlexCol = ({ className = '', children }) => <div className={`flex flex-col ${className}`}>{children}</div>;
